import { MicroAppsService } from '../resources/microapps.service';
import { Model } from '../common/model';

export class MicroAppModel extends Model {
  get name(): string {
    return this._data.name;
  }

  set name(value: string) {
    this._data.name = value;
  }

  get type(): any {
    return this._data.type;
  }

  set type(value: any) {
    this._data.type = value;
  }

  get parents(): any {
    return this._data.parents;
  }

  set parents(value: any) {
    this._data.parents = value;
  }

  get settings(): any {
    return this._data.settings;
  }

  set settings(value: any) {
    this._data.settings = value;
  }

  constructor(protected microAppsService: MicroAppsService, data: any) {
    super(microAppsService, data);
  }
}
